import DomEvents from './domevents'
import idx from 'idx'

export { DomEvents }

export const disposeAnimations = ({ mixers, actions, clips }) => {
    try {
        Object.keys(mixers).forEach(mixerKey => {
            Object.keys(actions[mixerKey]).forEach(actionClipkey => {
                const action = idx(mixers, _ => _[mixerKey][actionClipkey])
                action && mixers[mixerKey].uncacheAction(action)
            })
            Object.keys(clips).forEach(clipKey => {
                const clip = idx(clips, _ => _[clipKey])
                clip && mixers[mixerKey].uncacheClip(clip)
            })

            const root = idx(mixers, _ => _[mixerKey].getRoot())
            root && mixers[mixerKey].uncacheRoot(root)

            mixers[mixerKey] = null
        })
    } catch (err) {
        console.log('utils.disposeAnimationMixer error: ' + err)
    }
}

export const dispose3DObject = obj => {
    if (obj !== null) {
        for (var i = 0; i < obj.children.length; i++) {
            dispose3DObject(obj.children[i])
        }
        if (obj.mesh) {
            obj.mesh.dispose()
            obj.mesh = undefined
        }
        if (obj.texture) {
            obj.texture.dispose()
            obj.texture = undefined
        }
        if (obj.geometry) {
            obj.geometry.dispose()
            obj.geometry = undefined
        }
        if (obj.material) {
            if (obj.material.map) {
                obj.material.map.dispose()
                obj.material.map = undefined
            }
            obj.material.dispose()
            obj.material = undefined
        }
    }
    obj = undefined
}

// Adapted from here: https://github.com/SeregPie/THREE.TextSprite/blob/master/src/getOptimalFontSize.js
// Note that scaling uses y axis.  This should be fine since we scale with constant aspect ratio
export const standardizeScale = (
    rootObj,
    camera,
    renderer,
    height,
    standardHeight = 100,
    heightScaleFactorAdjustment = 1,
    floor = 0.4,
    ceiling = 1.75
) => {
    let cameraWorldPosition = new THREE.Vector3()
    let rootWorldPosition = new THREE.Vector3()
    let rootWorldScale = new THREE.Vector3()
    let zoomFactor = camera.zoom ? camera.zoom : 1

    // Gets object's position in world terms
    rootObj.getWorldPosition(rootWorldPosition)

    // Gets camera's position in world terms
    camera.getWorldPosition(cameraWorldPosition)

    // Gets distance between root and camera in world terms
    let worldDistanceBetweenRootAndCamera = rootWorldPosition.distanceTo(cameraWorldPosition)

    // https://stackoverflow.com/questions/52193732/three-js-calculating-camera-fov-from-its-position-and-vice-versa
    // https://stackoverflow.com/questions/13350875/three-js-width-of-view/13351534#13351534
    // Calculates visible height based on camera's fov
    var inverseDistanceFromFov = 2 * Math.tan(THREE.Math.degToRad(camera.fov) / 2)
    let visibleHeight = inverseDistanceFromFov * worldDistanceBetweenRootAndCamera

    let scalingFactor
    if (visibleHeight) {
        // https://threejs.org/docs/#api/en/core/Object3D.getWorldScale
        // Returns a vector of the scaling factors applied to the object for each axis in world space.
        rootObj.getWorldScale(rootWorldScale)

        // Calculates root height by combining root's world scale with visible height of renderer (renderer.domElement.height / visibleHeight)
        let rootHeightInPixels = (rootWorldScale.y * renderer.domElement.height) / visibleHeight
        if (rootHeightInPixels) {
            // Determines scaling factor by dividing desired height (standardHeight) by current height, offset by how close in the camera is zoomed
            scalingFactor = standardHeight / (Math.round(rootHeightInPixels / height) * zoomFactor)
        }
    }
    // Note use of floor and ceiling to keep standardization scaling within acceptable ranges.
    // Most useful for making sure viewport height and width changes in non-standard window sizes don't cause unacceptably large or small scales
    if (scalingFactor) {
        rootObj.scale.set(
            Math.min(Math.max(rootObj.scale.x * scalingFactor, floor), ceiling),
            Math.min(Math.max(rootObj.scale.y * scalingFactor, floor), ceiling) * heightScaleFactorAdjustment,
            Math.min(Math.max(rootObj.scale.z * scalingFactor, floor), ceiling)
        )
    }
    return rootObj
}
